export interface DoctorProfile {
  slug: string;
  nameEn: string;
  nameAr: string;
  specialtyEn: string;
  specialtyAr: string;
  nationalityEn: string;
  nationalityAr: string;
  languagesEn: string[];
  languagesAr: string[];
  licenseEn: string;
  licenseAr: string;
  experienceYears: number;
  educationEn: string[];
  educationAr: string[];
  bioEn: string;
  bioAr: string;
  servicesEn: string[];
  servicesAr: string[];
  certificationsEn: string[];
  certificationsAr: string[];
  photoUrl: string;
  videoUrl: string;
  videoOrientation?: "portrait" | "landscape" | "square";
  waMsgEn: string;
  waMsgAr: string;
}

const doctorProfiles: DoctorProfile[] = [
  {
    slug: "dr-radwa-abdulhadi",
    nameEn: "Dr. Radwa Abdulhadi",
    nameAr: "د. رضوى عبدالهادي",
    specialtyEn: "Aesthetic & Cosmetic Dermatologist",
    specialtyAr: "أخصائية جلدية تجميلية",
    nationalityEn: "",
    nationalityAr: "",
    languagesEn: ["Arabic", "English"],
    languagesAr: ["العربية", "الإنجليزية"],
    licenseEn: "DHA Licensed",
    licenseAr: "مرخصة من هيئة الصحة بدبي",
    experienceYears: 10,
    educationEn: [
      "Bachelor of Medicine — Faculty of Medicine, Assuit University",
      "Master of Dermatology and Andrology — Al Fayoum University",
      "Advanced Aesthetic Course — Sharjah University"
    ],
    educationAr: [
      "بكالوريوس الطب — كلية الطب، جامعة أسيوط",
      "ماجستير الأمراض الجلدية والذكورة — جامعة الفيوم",
      "دورة تجميل متقدمة — جامعة الشارقة"
    ],
    bioEn: "Dr. Radwa Abdulhadi is a DHA-licensed Aesthetic and Cosmetic Dermatologist with over 10 years of experience. She holds a Master's degree in Dermatology and Andrology and has been serving patients at Bella Rose Medical Center since 2021. She specializes in Botox, fillers, laser treatments, and advanced skin rejuvenation procedures. Dr. Radwa is a UAE Golden Visa holder recognized for her expertise in cosmetic dermatology.",
    bioAr: "د. رضوى عبدالهادي أخصائية جلدية تجميلية مرخصة من هيئة الصحة بدبي بخبرة تزيد عن 10 سنوات. حاصلة على ماجستير في الأمراض الجلدية والذكورة وتخدم المرضى في مركز بيلا روز الطبي منذ 2021. متخصصة في البوتكس والفيلر وعلاجات الليزر وإجراءات تجديد البشرة المتقدمة. حاصلة على الإقامة الذهبية في الإمارات تقديراً لخبرتها في طب الجلدية التجميلي.",
    servicesEn: [
      "Botox Injection",
      "Filler Injection",
      "Thread Lift",
      "Laser Hair Removal",
      "Fractional CO2 Laser",
      "Micro Needling",
      "Mesotherapy",
      "Chemical Peeling",
      "PRP Therapy",
      "Dermoscopy & Trichoscopy"
    ],
    servicesAr: [
      "حقن البوتكس",
      "حقن الفيلر",
      "خيوط شد الوجه",
      "إزالة الشعر بالليزر",
      "ليزر CO2 الجزئي",
      "ميكرو نيدلينج",
      "ميزوثيرابي",
      "تقشير كيميائي",
      "علاج PRP",
      "ديرموسكوبي وتريكوسكوبي"
    ],
    certificationsEn: [
      "DHA Licensed — General Practitioner",
      "UAE Golden Visa Holder",
      "Laser Applications in Dermatology — Cairo University",
      "Botox and Filler Training — Cairo University",
      "Trichoscopy and Dermoscopy Certification",
      "Egyptian Society of Dermatology and Venereology"
    ],
    certificationsAr: [
      "ترخيص هيئة الصحة بدبي — طبيب عام",
      "حاملة الإقامة الذهبية في الإمارات",
      "تطبيقات الليزر في الأمراض الجلدية — جامعة القاهرة",
      "تدريب البوتكس والفيلر — جامعة القاهرة",
      "شهادة التريكوسكوبي والديرموسكوبي",
      "الجمعية المصرية للأمراض الجلدية والتناسلية"
    ],
    photoUrl: "/manus-storage/5987763059142889299_57fe3410.jpg",
    videoUrl: "/manus-storage/rad_1bb47ced.mp4",
    waMsgEn: "Hi, I'd like to book an appointment with Dr. Radwa Abdulhadi.",
    waMsgAr: "مرحباً، أريد حجز موعد مع د. رضوى عبدالهادي."
  },
  {
    slug: "dr-fatima-salah",
    nameEn: "Dr. Fatima Salah",
    nameAr: "د. فاطمة صلاح",
    specialtyEn: "Aesthetic Doctor",
    specialtyAr: "طبيبة تجميل",
    nationalityEn: "",
    nationalityAr: "",
    languagesEn: ["Arabic", "English"],
    languagesAr: ["العربية", "الإنجليزية"],
    licenseEn: "DHA Licensed",
    licenseAr: "مرخصة من هيئة الصحة بدبي",
    experienceYears: 5,
    educationEn: [
      "Bachelor of Medicine and Surgery — Nahda College",
      "Diploma of American Board of Aesthetic",
      "Training under supervision of Dermatologist and Plastic Surgeon"
    ],
    educationAr: [
      "بكالوريوس الطب والجراحة — كلية النهضة",
      "دبلوم البورد الأمريكي للتجميل",
      "تدريب تحت إشراف طبيب جلدية وجراح تجميل"
    ],
    bioEn: "Dr. Fatima Salah is a passionate Aesthetic Doctor with a strong foundation in medicine and a specialized focus on non-surgical aesthetic treatments. She completed her DHA medical internship at HMS Mirdif Private Hospital across multiple departments including general surgery, obstetrics, anaesthesia, and pediatrics. With her Diploma from the American Board of Aesthetic and hands-on training under dermatology and plastic surgery specialists, Dr. Fatima Salah delivers natural-looking results in facial rejuvenation, skin care, and body aesthetics. She is also an active researcher with publications in pediatric medicine and a speaker at DHA academic events.",
    bioAr: "د. فاطمة صلاح طبيبة تجميل شغوفة ذات أساس قوي في الطب وتخصص في العلاجات التجميلية غير الجراحية. أكملت تدريبها الطبي في مستشفى HMS المردف الخاص تحت إشراف هيئة الصحة بدبي في عدة أقسام تشمل الجراحة العامة والنساء والتخدير والأطفال. بحصولها على دبلوم البورد الأمريكي للتجميل وتدريبها العملي تحت إشراف متخصصين في الجلدية والجراحة التجميلية، تقدم د. فاطمة صلاح نتائج طبيعية في تجديد شباب الوجه والعناية بالبشرة وتجميل الجسم. كما أنها باحثة نشطة لديها منشورات في طب الأطفال ومتحدثة في الفعاليات الأكاديمية لهيئة الصحة بدبي.",
    servicesEn: [
      "Botox Injections",
      "Dermal Fillers",
      "Lip Enhancement",
      "Skin Boosters",
      "Mesotherapy",
      "PRP Therapy",
      "Chemical Peels",
      "Facial Rejuvenation",
      "Under-Eye Treatment",
      "Anti-Aging Treatments",
      "Skin Tightening",
      "Acne Scar Treatment"
    ],
    servicesAr: [
      "حقن البوتكس",
      "الفيلر",
      "تكبير الشفاه",
      "سكن بوستر",
      "الميزوثيرابي",
      "العلاج بالبلازما",
      "التقشير الكيميائي",
      "تجديد شباب الوجه",
      "علاج تحت العين",
      "علاجات مكافحة الشيخوخة",
      "شد البشرة",
      "علاج آثار حب الشباب"
    ],
    certificationsEn: [
      "DHA Medical Internship — HMS Mirdif Private Hospital",
      "Diploma of American Board of Aesthetic",
      "Basic Life Support (BLS) — Cornerstone Advanced Training",
      "Speaker at DHA Medical Intern Academic Day",
      "Published Research — Journal of MAR Pediatrics",
      "King's College Hospital Pediatric Conference",
      "SANID Civil Protection and Safety Initiative"
    ],
    certificationsAr: [
      "تدريب طبي من هيئة الصحة بدبي — مستشفى HMS المردف الخاص",
      "دبلوم البورد الأمريكي للتجميل",
      "شهادة الإنعاش الأساسي (BLS) — كورنرستون للتدريب المتقدم",
      "متحدثة في اليوم الأكاديمي للمتدربين الطبيين بهيئة الصحة بدبي",
      "بحث منشور — مجلة MAR لطب الأطفال",
      "مؤتمر مستشفى كينغز كوليدج لطب الأطفال",
      "مبادرة سند للحماية المدنية والسلامة"
    ],
    photoUrl: "/manus-storage/5987763059142889300_92b216a4.jpg",
    videoUrl: "/manus-storage/faaaaaaaaaatmaaaaa_b0aa6091.mp4",
    waMsgEn: "Hi, I'd like to book an appointment with Dr. Fatima Salah.",
    waMsgAr: "مرحباً، أريد حجز موعد مع د. فاطمة صلاح."
  },
  {
    slug: "dr-samira-mohammadi",
    nameEn: "Dr. Samira Mohammadi",
    nameAr: "د. سميرة محمدي",
    specialtyEn: "Senior Hair Transplant Specialist",
    specialtyAr: "أخصائية زراعة شعر أولى",
    nationalityEn: "Iranian",
    nationalityAr: "إيرانية",
    languagesEn: ["English", "Persian", "Arabic (Basic)"],
    languagesAr: ["الإنجليزية", "الفارسية", "العربية (أساسي)"],
    licenseEn: "DHA Licensed Beauty Therapist",
    licenseAr: "أخصائية تجميل مرخصة من هيئة الصحة بدبي",
    experienceYears: 13,
    educationEn: [
      "DHA Licensed Beauty Therapist — Dubai Health Authority",
      "Certificate in Advanced FUE & DHI",
      "Infection Control & Patient Safety Certification"
    ],
    educationAr: [
      "أخصائية تجميل مرخصة — هيئة الصحة بدبي",
      "شهادة في تقنيات FUE و DHI المتقدمة",
      "شهادة مكافحة العدوى وسلامة المرضى"
    ],
    bioEn: "Dr. Samira Mohammadi is a Senior Hair Transplant Specialist with over 13 years of experience in advanced hair restoration procedures. She specializes in FUE, DHI, and PRP techniques, with extensive experience in the UAE market. As Department Lead at a leading Dubai clinic, Dr. Samira develops comprehensive hair restoration treatment plans and leads a team of technicians. She is committed to delivering natural, high-density results under international medical standards, with thousands of successful grafts to her name.",
    bioAr: "د. سميرة محمدي أخصائية زراعة شعر أولى تتمتع بخبرة تزيد عن 13 عاماً في إجراءات استعادة الشعر المتقدمة. متخصصة في تقنيات FUE و DHI و PRP، مع خبرة واسعة في سوق الإمارات. كرئيسة قسم في عيادة رائدة في دبي، تطور د. سميرة خطط علاج شاملة لاستعادة الشعر وتقود فريقاً من الفنيين. ملتزمة بتقديم نتائج طبيعية عالية الكثافة وفق المعايير الطبية الدولية، مع آلاف عمليات الزراعة الناجحة.",
    servicesEn: [
      "FUE Hair Transplant",
      "DHI Hair Transplant",
      "PRP Therapy for Hair",
      "Hairline Design & Restoration",
      "Beard & Eyebrow Transplant",
      "Hair Loss Consultation",
      "Scalp Treatment & Care"
    ],
    servicesAr: [
      "زراعة الشعر بتقنية FUE",
      "زراعة الشعر بتقنية DHI",
      "علاج PRP للشعر",
      "تصميم واستعادة خط الشعر",
      "زراعة اللحية والحواجب",
      "استشارة تساقط الشعر",
      "علاج والعناية بفروة الرأس"
    ],
    certificationsEn: [
      "DHA Licensed Beauty Therapist — Dubai Health Authority",
      "Advanced FUE & DHI Certification",
      "Infection Control & Patient Safety Certification",
      "13+ Years of Specialized Hair Restoration Experience"
    ],
    certificationsAr: [
      "أخصائية تجميل مرخصة — هيئة الصحة بدبي",
      "شهادة FUE و DHI المتقدمة",
      "شهادة مكافحة العدوى وسلامة المرضى",
      "خبرة متخصصة تزيد عن 13 عاماً في استعادة الشعر"
    ],
    photoUrl: "/manus-storage/5987763059142889302_50750dd0.jpg",
    videoUrl: "/manus-storage/doctor-samira-video_6259f2c8.mp4",
    waMsgEn: "Hi, I'd like to book an appointment with Dr. Samira Mohammadi.",
    waMsgAr: "مرحباً، أريد حجز موعد مع د. سميرة محمدي."
  },
  {
    slug: "dr-mohammad-khadour",
    nameEn: "Dr. Mohammad Khadour",
    nameAr: "د. محمد خضور",
    specialtyEn: "Aesthetic Doctor",
    specialtyAr: "طبيب تجميل",
    nationalityEn: "Syrian",
    nationalityAr: "سوري",
    languagesEn: ["Arabic", "English"],
    languagesAr: ["العربية", "الإنجليزية"],
    licenseEn: "DHA Licensed",
    licenseAr: "مرخص من هيئة الصحة بدبي",
    experienceYears: 9,
    educationEn: [
      "Certificate in Medicine — Tishreen University, Syria",
      "Master Degree in Surgery — Tishreen University, Syria",
      "License in General Medicine — Dubai",
      "Certificate in Aesthetic Medicine — Dubai"
    ],
    educationAr: [
      "شهادة في الطب — جامعة تشرين، سوريا",
      "ماجستير في الجراحة — جامعة تشرين، سوريا",
      "ترخيص في الطب العام — دبي",
      "شهادة في الطب التجميلي — دبي"
    ],
    bioEn: "Dr. Mohammad Khadour is an experienced Aesthetic Doctor with a Master's degree in Surgery and focused expertise in dermatology and non-surgical facial rejuvenation. With over 9 years of medical experience spanning Syria, Kuwait, and Dubai, he specializes in advanced dermatology and aesthetic techniques including Botox, fillers, biostimulators, threads, skin rejuvenation, and facial contouring. At Bella Rose Medical Center, Dr. Khadour combines his surgical background with evidence-based dermatology care to deliver natural-looking, individualized results.",
    bioAr: "د. محمد خضور طبيب تجميل ذو خبرة واسعة حاصل على ماجستير في الجراحة، وتركز خبرته على الجلدية وتجديد شباب الوجه غير الجراحي. بخبرة طبية تزيد عن 9 سنوات في سوريا والكويت ودبي، يتخصص في تقنيات الجلدية والتجميل المتقدمة بما يشمل البوتكس والفيلر والمحفزات الحيوية والخيوط وتجديد البشرة ونحت ملامح الوجه. في مركز بيلا روز الطبي، يجمع د. خضور بين خلفيته الجراحية والرعاية الجلدية القائمة على الأدلة لتقديم نتائج طبيعية وخطط علاج فردية.",
    servicesEn: [
      "Botox Injections",
      "Dermal Fillers",
      "Biostimulators (Sculptra, Radiesse)",
      "Thread Lift",
      "Non-Surgical Face Lift",
      "Skin Rejuvenation",
      "Jawline Contouring",
      "Lip Enhancement",
      "Under-Eye Filler"
    ],
    servicesAr: [
      "حقن البوتكس",
      "الفيلر",
      "المحفزات الحيوية (سكلبترا، راديس)",
      "شد الوجه بالخيوط",
      "شد الوجه غير الجراحي",
      "تجديد البشرة",
      "نحت خط الفك",
      "تكبير الشفاه",
      "فيلر تحت العين"
    ],
    certificationsEn: [
      "Master Degree in Surgery — Tishreen University",
      "DHA Licensed — General Medicine, Dubai",
      "Certificate in Aesthetic Medicine — Dubai",
      "Registered Doctor — Kuwait",
      "Resident Doctor — Tishreen University Hospital"
    ],
    certificationsAr: [
      "ماجستير في الجراحة — جامعة تشرين",
      "مرخص من هيئة الصحة بدبي — الطب العام",
      "شهادة في الطب التجميلي — دبي",
      "طبيب مسجل — الكويت",
      "طبيب مقيم — مستشفى جامعة تشرين"
    ],
    photoUrl: "/manus-storage/5987763059142889307_4dd07c7d.jpg",
    videoUrl: "/manus-storage/khadour-web_6dc19f18.mp4",
    waMsgEn: "Hi, I'd like to book an appointment with Dr. Mohammad Khadour.",
    waMsgAr: "مرحباً، أريد حجز موعد مع د. محمد خضور."
  },
  {
    slug: "dr-mohammed-alsammarraie",
    nameEn: "Dr. Mohammed Alsammarraie",
    nameAr: "د. محمد السامرائي",
    specialtyEn: "Implantologist & Periodontist",
    specialtyAr: "أخصائي زراعة أسنان وأمراض اللثة",
    nationalityEn: "Iraqi",
    nationalityAr: "عراقي",
    languagesEn: ["Arabic", "English"],
    languagesAr: ["العربية", "الإنجليزية"],
    licenseEn: "DHA & MOH Licensed (GP with Implant Privilege)",
    licenseAr: "مرخص من هيئة الصحة بدبي ووزارة الصحة (طبيب عام مع امتياز الزراعة)",
    experienceYears: 10,
    educationEn: [
      "Master's Degree in Periodontology & Implantology — Ain Shams University, Egypt",
      "Internship Program — Ajman University, UAE"
    ],
    educationAr: [
      "ماجستير في أمراض اللثة وزراعة الأسنان — جامعة عين شمس، مصر",
      "برنامج تدريب — جامعة عجمان، الإمارات"
    ],
    bioEn: "Dr. Mohammed Alsammarraie is an experienced Implantologist and Periodontist with over 10 years of clinical practice. He holds a Master's degree in Periodontology and Implantology from Ain Shams University and is licensed by both DHA and MOH with implant privileges. Specialized in surgical and regenerative procedures including GBR, sinus lifts, ridge splitting, and GTR, Dr. Mohammed has successfully placed and restored over 200 implants. He is also proficient in LASER dentistry, zirconia implants, and clear aligners.",
    bioAr: "د. محمد السامرائي أخصائي زراعة أسنان وأمراض لثة ذو خبرة تزيد عن 10 سنوات في الممارسة السريرية. حاصل على ماجستير في أمراض اللثة وزراعة الأسنان من جامعة عين شمس، ومرخص من هيئة الصحة بدبي ووزارة الصحة مع امتياز الزراعة. متخصص في الإجراءات الجراحية والتجديدية بما في ذلك تجديد العظم الموجه ورفع الجيب الفكي وتقسيم الحافة، وقد نجح في زراعة وترميم أكثر من 200 زرعة. كما يتقن طب الأسنان بالليزر وزراعات الزركونيا والتقويم الشفاف.",
    servicesEn: [
      "Dental Implants (Titanium & Zirconia)",
      "Guided Bone Regeneration (GBR)",
      "Sinus Lift Surgery",
      "Ridge Splitting",
      "Periodontal Surgery",
      "Gum Disease Treatment",
      "LASER Dentistry",
      "Clear Aligners",
      "Cosmetic Dentistry",
      "Restorative Dentistry",
      "Pediatric Dentistry",
      "CAD/CAM Digital Dentistry"
    ],
    servicesAr: [
      "زراعة الأسنان (تيتانيوم وزركونيا)",
      "تجديد العظم الموجه (GBR)",
      "جراحة رفع الجيب الفكي",
      "تقسيم الحافة العظمية",
      "جراحة اللثة",
      "علاج أمراض اللثة",
      "طب الأسنان بالليزر",
      "التقويم الشفاف",
      "طب الأسنان التجميلي",
      "طب الأسنان الترميمي",
      "طب أسنان الأطفال",
      "طب الأسنان الرقمي CAD/CAM"
    ],
    certificationsEn: [
      "Advanced Digital Implantology Course — AEEDC, Dubai",
      "Modern Dental Implantology — 5 Modules (25 CME Credits), MIS Academy Dubai",
      "14th Dental Facial Cosmetic Conference — CAAP",
      "17th CAD/CAM & Digital Dentistry Conference",
      "Smile Design Rules — Mastery Academy",
      "BDS & MSc Equivalency Exam — University of Baghdad",
      "Registered Specialist Periodontist — Iraqi Dental Association"
    ],
    certificationsAr: [
      "دورة متقدمة في زراعة الأسنان الرقمية — AEEDC، دبي",
      "زراعة الأسنان الحديثة — 5 وحدات (25 ساعة تعليم مستمر)، أكاديمية MIS دبي",
      "المؤتمر الرابع عشر لتجميل الوجه والأسنان — CAAP",
      "المؤتمر السابع عشر لطب الأسنان الرقمي CAD/CAM",
      "قواعد تصميم الابتسامة — أكاديمية الإتقان",
      "امتحان معادلة BDS وماجستير — جامعة بغداد",
      "أخصائي لثة مسجل — نقابة أطباء الأسنان العراقية"
    ],
    photoUrl: "/manus-storage/5987763059142889303_3c699983.jpg",
    videoUrl: "/manus-storage/doctor-mohamed-video_64a934b5.mp4",
    waMsgEn: "Hi, I'd like to book an appointment with Dr. Mohammed Alsammarraie.",
    waMsgAr: "مرحباً، أريد حجز موعد مع د. محمد السامرائي."
  },
  {
    slug: "dr-hassan-alhouri",
    nameEn: "Dr. Hasan Alhouri",
    nameAr: "د. حسن الحوري",
    specialtyEn: "General Dentist & Cosmetic Specialist",
    specialtyAr: "طبيب أسنان عام ومتخصص في التجميل",
    nationalityEn: "Syrian",
    nationalityAr: "سوري",
    languagesEn: ["Arabic", "English"],
    languagesAr: ["العربية", "الإنجليزية"],
    licenseEn: "DHA Licensed",
    licenseAr: "مرخص من هيئة الصحة بدبي",
    experienceYears: 6,
    educationEn: [
      "Bachelor of Dentistry (BDS) — Al Andalus Private University, Syria"
    ],
    educationAr: [
      "بكالوريوس طب الأسنان — جامعة الأندلس الخاصة، سوريا"
    ],
    bioEn: "Dr. Hasan Alhouri is a skilled General Dentist with over 6 years of clinical experience in comprehensive dental care. Licensed by both the Dubai Health Authority and the Syrian Ministry of Health, he specializes in cosmetic dentistry, smile rehabilitation, veneers, and professional teeth whitening. At Bella Rose Medical Center, Dr. Hasan provides evidence-based treatment plans using digital intraoral scanners and modern clinical workflows. He is known for his patient-centered approach and meticulous attention to detail.",
    bioAr: "د. حسن الحوري طبيب أسنان ماهر يتمتع بخبرة سريرية تزيد عن 6 سنوات في رعاية الأسنان الشاملة. مرخص من هيئة الصحة بدبي ووزارة الصحة السورية، متخصص في طب الأسنان التجميلي وإعادة تأهيل الابتسامة والقشور وتبييض الأسنان الاحترافي. في مركز بيلا روز الطبي، يقدم د. حسن خطط علاج مبنية على الأدلة باستخدام الماسحات الرقمية داخل الفم وسير العمل السريري الحديث. يُعرف بنهجه المتمحور حول المريض واهتمامه الدقيق بالتفاصيل.",
    servicesEn: [
      "Cosmetic Dentistry & Smile Design",
      "Veneers (Zircon & E-max)",
      "Professional Teeth Whitening",
      "Dental Crowns & Bridges",
      "Root Canal Treatment",
      "Tooth Extractions",
      "Dental Restorations",
      "Dentures & Prosthetics",
      "Scaling & Polishing",
      "Dental Photography",
      "Digital Impressions (Intraoral Scanner)"
    ],
    servicesAr: [
      "طب الأسنان التجميلي وتصميم الابتسامة",
      "قشور (زركون وإيماكس)",
      "تبييض الأسنان الاحترافي",
      "تيجان وجسور الأسنان",
      "علاج العصب",
      "خلع الأسنان",
      "ترميم الأسنان",
      "أطقم الأسنان والتركيبات",
      "تنظيف وتلميع",
      "تصوير الأسنان",
      "طبعات رقمية (ماسح داخل الفم)"
    ],
    certificationsEn: [
      "DHA Licensed Dentist — Dubai Health Authority",
      "Licensed Dentist — Ministry of Health, Syria",
      "36-Hour Accredited Course: Art of Anterior Teeth — Syrian Dental Syndicate",
      "Internal Clinical Training — Bioscience Institute, Clinica Sabah",
      "Member of the Syrian Dental Syndicate"
    ],
    certificationsAr: [
      "طبيب أسنان مرخص — هيئة الصحة بدبي",
      "طبيب أسنان مرخص — وزارة الصحة السورية",
      "دورة معتمدة 36 ساعة: فن الأسنان الأمامية — نقابة أطباء الأسنان السورية",
      "تدريب سريري داخلي — معهد العلوم الحيوية، كلينيكا صباح",
      "عضو نقابة أطباء الأسنان السورية"
    ],
    photoUrl: "/manus-storage/5987763059142889301_8790c4a4.jpg",
    videoUrl: "/manus-storage/doctor-hassan-video_192fdd08.mp4",
    waMsgEn: "Hi, I'd like to book an appointment with Dr. Hasan Alhouri.",
    waMsgAr: "مرحباً، أريد حجز موعد مع د. حسن الحوري."
  },
  {
    slug: "dr-farouk-khallaf",
    nameEn: "Dr. Farouk Khallaf",
    nameAr: "د. فاروق خلاف",
    specialtyEn: "Plastic Surgery Specialist",
    specialtyAr: "أخصائي جراحة تجميلية",
    nationalityEn: "Egyptian",
    nationalityAr: "مصري",
    languagesEn: ["Arabic", "English"],
    languagesAr: ["العربية", "الإنجليزية"],
    licenseEn: "DHA Eligibility Letter",
    licenseAr: "خطاب أهلية من هيئة الصحة بدبي",
    experienceYears: 8,
    educationEn: [
      "Bachelor of Medicine and Surgery (MBBCh) — Faculty of Medicine, Menofia University, Egypt (2017)"
    ],
    educationAr: [
      "بكالوريوس الطب والجراحة — كلية الطب، جامعة المنوفية، مصر (2017)"
    ],
    bioEn: "Dr. Farouk Khallaf is a dedicated Plastic Surgery Specialist with extensive hands-on experience in emergency plastic surgery, trauma care, and wound management. He has contributed to over 100 emergency procedures including wound closures, skin grafts, and soft tissue repairs across multiple hospitals. At Bella Rose Medical Center, Dr. Farouk specializes in aesthetic and reconstructive procedures, bringing a meticulous surgical approach to every case. His training spans critical care, neurosurgery, and emergency medicine.",
    bioAr: "د. فاروق خلاف أخصائي جراحة تجميلية متفانٍ يتمتع بخبرة عملية واسعة في الجراحة التجميلية الطارئة ورعاية الإصابات وإدارة الجروح. ساهم في أكثر من 100 إجراء طارئ بما في ذلك إغلاق الجروح وترقيع الجلد وإصلاح الأنسجة الرخوة في عدة مستشفيات. في مركز بيلا روز الطبي، يتخصص د. فاروق في الإجراءات التجميلية والترميمية، حيث يجلب نهجاً جراحياً دقيقاً لكل حالة.",
    servicesEn: [
      "Wound Closure & Repair",
      "Skin Grafts",
      "Soft Tissue Reconstruction",
      "Facial Trauma Repair",
      "Scar Revision",
      "Burn Management",
      "Post-Surgical Recovery Care",
      "Aesthetic Consultations"
    ],
    servicesAr: [
      "إغلاق وإصلاح الجروح",
      "ترقيع الجلد",
      "إعادة بناء الأنسجة الرخوة",
      "إصلاح إصابات الوجه",
      "تصحيح الندبات",
      "إدارة الحروق",
      "رعاية ما بعد الجراحة",
      "استشارات تجميلية"
    ],
    certificationsEn: [
      "Egyptian Fellowship in Plastic Surgery — Sheikh Zayed Specialized Hospital",
      "Critical Care Unit Training — Air Force General Hospital, Cairo",
      "NICU Training — Yasmeen Hospital Al Maadi",
      "ICU Training — Dar AlSeha Hospital",
      "Internship — University Hospital Specialist Shebeen"
    ],
    certificationsAr: [
      "الزمالة المصرية في الجراحة التجميلية — مستشفى الشيخ زايد التخصصي",
      "تدريب وحدة العناية المركزة — مستشفى القوات الجوية، القاهرة",
      "تدريب العناية المركزة لحديثي الولادة — مستشفى ياسمين المعادي",
      "تدريب العناية المركزة — مستشفى دار الصحة",
      "تدريب — المستشفى الجامعي التخصصي شبين"
    ],
    photoUrl: "/manus-storage/5987763059142889306_b019813b.jpg",
    videoUrl: "/manus-storage/doctor-farouk-video_5e9196ac.mp4",
    waMsgEn: "Hi, I'd like to book an appointment with Dr. Farouk Khallaf.",
    waMsgAr: "مرحباً، أريد حجز موعد مع د. فاروق خلاف."
  },
  {
    slug: "dr-aaya-alsadi",
    nameEn: "Dr. Aaya Alsadi",
    nameAr: "د. آية السعدي",
    specialtyEn: "General Dentist & Cosmetic Specialist",
    specialtyAr: "طبيبة أسنان عامة ومتخصصة في التجميل",
    nationalityEn: "Syrian",
    nationalityAr: "سورية",
    languagesEn: ["Arabic", "English"],
    languagesAr: ["العربية", "الإنجليزية"],
    licenseEn: "DHA & MOH Licensed",
    licenseAr: "مرخصة من هيئة الصحة بدبي ووزارة الصحة",
    experienceYears: 4,
    educationEn: [
      "Bachelor of Dental Surgery — Gulf Medical University, Ajman (2023)"
    ],
    educationAr: [
      "بكالوريوس جراحة الأسنان — جامعة الخليج الطبية، عجمان (2023)"
    ],
    bioEn: "Dr. Aaya Alsadi is a dedicated General Dentist and Cosmetic Specialist with a deep passion for delivering advanced and comprehensive dental care. She served as Medical Director at Bella Rose Medical Center, where she focused on smile design, veneers, composite bonding, and teeth whitening. With extensive experience across multiple clinics in the UAE, Dr. Aaya is known for her meticulous attention to aesthetics and individualized treatment planning that ensures high patient satisfaction.",
    bioAr: "د. آية السعدي طبيبة أسنان عامة ومتخصصة في التجميل، تتميز بشغفها العميق لتقديم رعاية أسنان متقدمة وشاملة. شغلت منصب المدير الطبي في مركز بيلا روز الطبي، حيث ركزت على تصميم الابتسامة والقشور التجميلية وتبييض الأسنان. بخبرتها الواسعة في عدة عيادات في الإمارات، تُعرف د. آية باهتمامها الدقيق بالجماليات والتخطيط العلاجي الفردي الذي يضمن رضا المرضى.",
    servicesEn: [
      "Smile Design & Makeover",
      "E-max Veneers",
      "Composite Bonding",
      "Teeth Whitening (Zoom)",
      "Diastema Closure",
      "Root Canal Treatment",
      "Dental Restorations",
      "Scaling & Polishing",
      "Pediatric Dentistry",
      "Clear Aligners",
      "Zirconia Crowns",
      "Gummy Smile Correction (Laser)"
    ],
    servicesAr: [
      "تصميم الابتسامة",
      "قشور إيماكس",
      "حشوات تجميلية",
      "تبييض الأسنان (زووم)",
      "إغلاق الفراغات",
      "علاج العصب",
      "ترميم الأسنان",
      "تنظيف وتلميع",
      "طب أسنان الأطفال",
      "التقويم الشفاف",
      "تيجان الزركونيا",
      "تصحيح الابتسامة اللثوية (ليزر)"
    ],
    certificationsEn: [
      "Basic Life Support (BLS) Certificate",
      "CAPP Conference Attendance",
      "AEEDC Conference Attendance",
      "Pediatric Dentistry Certificate — Apolonia Clinic",
      "Clear Aligner Workshop Certificate",
      "Endodontics Workshop — Manual-less Root Canal Treatment",
      "The Art and Science of Ceramic Veneers Workshop"
    ],
    certificationsAr: [
      "شهادة الإنعاش الأساسي (BLS)",
      "حضور مؤتمر CAPP",
      "حضور مؤتمر AEEDC",
      "شهادة طب أسنان الأطفال — عيادة أبولونيا",
      "شهادة ورشة التقويم الشفاف",
      "ورشة علاج العصب — بدون أدوات يدوية",
      "ورشة فن وعلم القشور الخزفية"
    ],
    photoUrl: "/manus-storage/5987763059142889305_35c6c919.jpg",
    videoUrl: "/manus-storage/doctor-aya-video_9c467fa0.mp4",
    waMsgEn: "Hi, I'd like to book an appointment with Dr. Aaya Alsadi.",
    waMsgAr: "مرحباً، أريد حجز موعد مع د. آية السعدي."
  },
  {
    slug: "dr-asmaa-ebied",
    nameEn: "Dr. Asmaa Ebied",
    nameAr: "د. أسماء عبيد",
    specialtyEn: "Physiotherapist & Hijama Specialist",
    specialtyAr: "أخصائية علاج طبيعي وحجامة",
    nationalityEn: "Egyptian",
    nationalityAr: "مصرية",
    languagesEn: ["Arabic", "English", "French (Basic)"],
    languagesAr: ["العربية", "الإنجليزية", "الفرنسية (أساسي)"],
    licenseEn: "MOH & SHA Licensed (Physiotherapy & Cupping)",
    licenseAr: "مرخصة من وزارة الصحة وهيئة الشارقة (علاج طبيعي وحجامة)",
    experienceYears: 5,
    educationEn: [
      "Bachelor's Degree in Physical Therapy — Faculty of Physical Therapy, Kafr El-Sheikh University, Egypt (2021)"
    ],
    educationAr: [
      "بكالوريوس العلاج الطبيعي — كلية العلاج الطبيعي، جامعة كفر الشيخ، مصر (2021)"
    ],
    bioEn: "Dr. Asmaa Ebied is a dedicated Physiotherapist and Hijama (Cupping Therapy) Specialist with a strong academic background and hands-on clinical experience. Licensed by both the Ministry of Health and Sharjah Health Authority for physiotherapy and cupping therapy, she brings expertise in orthopedic rehabilitation, manual therapy, and traditional cupping techniques. With experience across multiple clinics in the UAE, Dr. Asmaa is passionate about helping patients achieve optimal physical health through evidence-based and holistic approaches.",
    bioAr: "د. أسماء عبيد أخصائية علاج طبيعي وحجامة متفانية تتمتع بخلفية أكاديمية قوية وخبرة سريرية عملية. مرخصة من وزارة الصحة وهيئة الصحة بالشارقة للعلاج الطبيعي والحجامة، تجلب خبرتها في إعادة التأهيل العظمي والعلاج اليدوي وتقنيات الحجامة التقليدية. بخبرتها في عدة عيادات في الإمارات، تحرص د. أسماء على مساعدة المرضى لتحقيق الصحة البدنية المثلى من خلال نهج قائم على الأدلة وشامل.",
    servicesEn: [
      "Hijama (Cupping Therapy)",
      "Dry Needling",
      "Orthopedic Rehabilitation",
      "Manual Therapy",
      "Sports Injury Recovery",
      "Back & Neck Pain Treatment",
      "Joint Pain Management",
      "Post-Surgery Rehabilitation",
      "Physiotherapy Assessment"
    ],
    servicesAr: [
      "الحجامة",
      "الإبر الجافة",
      "إعادة التأهيل العظمي",
      "العلاج اليدوي",
      "علاج الإصابات الرياضية",
      "علاج آلام الظهر والرقبة",
      "إدارة آلام المفاصل",
      "إعادة التأهيل بعد الجراحة",
      "تقييم العلاج الطبيعي"
    ],
    certificationsEn: [
      "Dry Needle Certificate — AIMS (2025)",
      "Basic Principles of Cupping Therapy — Sharjah International Holistic Centre (2024)",
      "BLS Certificate CPR & First Aid — American Heart Association (2024)",
      "Alfa Care Orthopedic Rehabilitation & Manual Therapy Program (170 hours, Grade A)",
      "International Foundation: Hijama & Dry Needle Practitioner (2022)",
      "MOH Licensed — Physical Therapy & Cupping Therapy",
      "SHA Licensed — Physical Therapy & Cupping Therapy"
    ],
    certificationsAr: [
      "شهادة الإبر الجافة — AIMS (2025)",
      "أساسيات العلاج بالحجامة — مركز الشارقة الدولي الشامل (2024)",
      "شهادة BLS والإسعافات الأولية — جمعية القلب الأمريكية (2024)",
      "برنامج ألفا كير لإعادة التأهيل العظمي والعلاج اليدوي (170 ساعة، تقدير A)",
      "المؤسسة الدولية: ممارس حجامة وإبر جافة (2022)",
      "مرخصة من وزارة الصحة — علاج طبيعي وحجامة",
      "مرخصة من هيئة الصحة بالشارقة — علاج طبيعي وحجامة"
    ],
    photoUrl: "/manus-storage/5987763059142889304_17cd7905.jpg",
    videoUrl: "/manus-storage/doctor-asma-video_6de3df3f.mp4",
    waMsgEn: "Hi, I'd like to book an appointment with Dr. Asmaa Ebied.",
    waMsgAr: "مرحباً، أريد حجز موعد مع د. أسماء عبيد."
  },
  {
    slug: "dr-rwaida-alkubati",
    nameEn: "Dr. Rwaida Al-Kubati",
    nameAr: "د. رويدة الكبتي",
    specialtyEn: "General Dentist",
    specialtyAr: "طبيبة أسنان عامة",
    nationalityEn: "Yemeni",
    nationalityAr: "يمنية",
    languagesEn: ["Arabic", "English"],
    languagesAr: ["العربية", "الإنجليزية"],
    licenseEn: "DHA Eligibility",
    licenseAr: "أهلية هيئة الصحة بدبي",
    experienceYears: 4,
    educationEn: [
      "Bachelor of Dentistry — University of Aden, Yemen",
      "Internship Training Certificate"
    ],
    educationAr: [
      "بكالوريوس طب الأسنان — جامعة عدن، اليمن",
      "شهادة التدريب العملي"
    ],
    bioEn: "Dr. Rwaida Al-Kubati is a highly skilled and patient-focused General Dentist with over 4 years of clinical experience across both premium government hospitals (DHA) and private practices in the UAE and Yemen. She is competent in advanced endodontics (rotary RCT), cosmetic dentistry including veneers and crowns, and comprehensive patient care. With her active track record in Dubai's healthcare sector, Dr. Rwaida is dedicated to delivering high-quality treatments and maximizing patient satisfaction.",
    bioAr: "د. رويدة الكبتي طبيبة أسنان عامة ماهرة ومتمحورة حول المريض، تتمتع بخبرة سريرية تزيد عن 4 سنوات في المستشفيات الحكومية المتميزة (هيئة الصحة بدبي) والعيادات الخاصة في الإمارات واليمن. متمكنة في علاج العصب المتقدم (الدوراني) وطب الأسنان التجميلي بما في ذلك القشور والتيجان والرعاية الشاملة للمرضى. بسجلها الحافل في قطاع الرعاية الصحية بدبي، تلتزم د. رويدة بتقديم علاجات عالية الجودة.",
    servicesEn: [
      "Root Canal Treatment (Rotary RCT)",
      "Cosmetic Dentistry",
      "Veneers & Crowns",
      "Dental Restorations",
      "Tooth Extractions (Simple & Surgical)",
      "Emergency Dental Care",
      "Scaling & Polishing",
      "Pediatric Dentistry",
      "Dental X-rays & Imaging"
    ],
    servicesAr: [
      "علاج العصب (الدوراني)",
      "طب الأسنان التجميلي",
      "قشور وتيجان",
      "ترميم الأسنان",
      "خلع الأسنان (بسيط وجراحي)",
      "رعاية الأسنان الطارئة",
      "تنظيف وتلميع",
      "طب أسنان الأطفال",
      "أشعة وتصوير الأسنان"
    ],
    certificationsEn: [
      "BLS / CPR Certification",
      "Advanced Endodontics Education Program",
      "Rotary Endodontics Course",
      "Restorative & Cosmetic Dentistry Courses",
      "Radiation Safety & Dental X-ray Certification",
      "Infection Control & Sterilization",
      "Emergency Dentistry Management",
      "Dental Photography Course"
    ],
    certificationsAr: [
      "شهادة الإنعاش الأساسي (BLS/CPR)",
      "برنامج علاج العصب المتقدم",
      "دورة علاج العصب الدوراني",
      "دورات طب الأسنان الترميمي والتجميلي",
      "شهادة السلامة الإشعاعية وأشعة الأسنان",
      "مكافحة العدوى والتعقيم",
      "إدارة طوارئ الأسنان",
      "دورة تصوير الأسنان"
    ],
    photoUrl: "/manus-storage/5987763059142889308_ac21f051.jpg",
    videoUrl: "/manus-storage/doctor-rouwaida-video_0177146f.mp4",
    waMsgEn: "Hi, I'd like to book an appointment with Dr. Rwaida Al-Kubati.",
    waMsgAr: "مرحباً، أريد حجز موعد مع د. رويدة الكبتي."
  },
  {
    slug: "nisreen-abdelmonaem",
    nameEn: "Nisreen Abdelmonaem",
    nameAr: "نسرين عبدالمنعم",
    specialtyEn: "Aesthetic & Laser Specialist",
    specialtyAr: "أخصائية تجميل وليزر",
    nationalityEn: "",
    nationalityAr: "",
    languagesEn: ["Arabic", "English"],
    languagesAr: ["العربية", "الإنجليزية"],
    licenseEn: "DHA Licensed",
    licenseAr: "مرخصة من هيئة الصحة بدبي",
    experienceYears: 15,
    educationEn: [
      "Diploma in Beauty Therapy — Newton Training Center, Dubai",
      "Laser Diploma — University of Sharjah (Solitare Laser)",
      "Skin Care Diploma — Premier Institute, Damascus"
    ],
    educationAr: [
      "دبلوم العلاج التجميلي — مركز نيوتن التدريبي، دبي",
      "دبلوم الليزر — جامعة الشارقة (سوليتير ليزر)",
      "دبلوم العناية بالبشرة — معهد بريمير، دمشق"
    ],
    bioEn: "Nisreen Abdelmonaem is an experienced and highly skilled Aesthetic Specialist with over 15 years of clinical expertise within premier medical centers and hospitals across Syria and the UAE. Specialized in advanced laser technologies, medical-grade skincare, and body contouring, she is a proven leader in clinic management and staff supervision. At Bella Rose Medical Center, Nisreen delivers personalized aesthetic treatments with meticulous attention to safety and results, combining her extensive experience with the latest techniques in laser hair removal, facial rejuvenation, and body care.",
    bioAr: "نسرين عبدالمنعم أخصائية تجميل ذات مهارات عالية وخبرة تزيد عن 15 عاماً في المراكز الطبية والمستشفيات الرائدة في سوريا والإمارات. متخصصة في تقنيات الليزر المتقدمة والعناية بالبشرة الطبية ونحت الجسم، وهي قائدة مثبتة في إدارة العيادات والإشراف على الكوادر. في مركز بيلا روز الطبي، تقدم نسرين علاجات تجميلية مخصصة مع اهتمام دقيق بالسلامة والنتائج، تجمع بين خبرتها الواسعة وأحدث التقنيات في إزالة الشعر بالليزر وتجديد شباب الوجه والعناية بالجسم.",
    servicesEn: [
      "Laser Hair Removal",
      "Advanced Facials",
      "Body Contouring",
      "Skin Analysis & Consultation",
      "Medical-Grade Skincare",
      "Body Care Treatments",
      "Customized Treatment Planning",
      "Skin Rejuvenation",
      "Anti-Aging Treatments",
      "Hydrafacial"
    ],
    servicesAr: [
      "إزالة الشعر بالليزر",
      "علاجات الوجه المتقدمة",
      "نحت الجسم",
      "تحليل البشرة والاستشارة",
      "العناية بالبشرة الطبية",
      "علاجات العناية بالجسم",
      "التخطيط العلاجي المخصص",
      "تجديد البشرة",
      "علاجات مكافحة الشيخوخة",
      "هيدرافيشل"
    ],
    certificationsEn: [
      "Diploma in Beauty Therapy — Newton Training Center, Dubai",
      "Laser Diploma — University of Sharjah",
      "Skin Care Diploma — Premier Institute, Damascus",
      "DHA Licensed — Aesthetic & Laser Specialist",
      "Medical Aesthetic Equipment Operations & Safety Compliance"
    ],
    certificationsAr: [
      "دبلوم العلاج التجميلي — مركز نيوتن التدريبي، دبي",
      "دبلوم الليزر — جامعة الشارقة",
      "دبلوم العناية بالبشرة — معهد بريمير، دمشق",
      "مرخصة من هيئة الصحة بدبي — أخصائية تجميل وليزر",
      "تشغيل أجهزة التجميل الطبية والامتثال للسلامة"
    ],
    photoUrl: "/manus-storage/6021749685111950531_201fa467.jpg",
    videoUrl: "/manus-storage/0726_be95f214.mp4",
    waMsgEn: "Hi, I'd like to book an appointment with Nisreen Abdelmonaem.",
    waMsgAr: "مرحباً، أريد حجز موعد مع نسرين عبدالمنعم."
  },
  {
    slug: "dr-ali-ahmad",
    nameEn: "Dr. Ali Ahmad",
    nameAr: "د. علي أحمد",
    specialtyEn: "General Practitioner",
    specialtyAr: "طبيب عام",
    nationalityEn: "",
    nationalityAr: "",
    languagesEn: ["Arabic", "English", "Russian"],
    languagesAr: ["العربية", "الإنجليزية", "الروسية"],
    licenseEn: "DHA Licensed General Practitioner",
    licenseAr: "طبيب عام مرخص من هيئة الصحة بدبي",
    experienceYears: 10,
    educationEn: [
      "Bachelor of Medicine — Ministry of Higher Education, Russian Federation"
    ],
    educationAr: [
      "بكالوريوس الطب — وزارة التعليم العالي، الاتحاد الروسي"
    ],
    bioEn: "Dr. Ali Ahmad is a DHA-licensed General Practitioner with more than 10 years of clinical experience across general practice, emergency medicine, acute care, and intensive-care follow-up. His professional background includes medical assessment for adults and children, weight management consultation, Endolift technology, minor procedures, wound care, patient counselling, and referral coordination. Dr. Ali provides consultation-led care in Arabic, English, and Russian, with treatment recommendations based on each patient’s medical assessment and individual needs.",
    bioAr: "د. علي أحمد طبيب عام مرخص من هيئة الصحة بدبي، يتمتع بخبرة سريرية تزيد عن 10 سنوات في الطب العام وطب الطوارئ والرعاية الحادة ومتابعة حالات العناية المركزة. تشمل خبرته المهنية التقييم الطبي للبالغين والأطفال، واستشارات إدارة الوزن، وتقنية إندولفت، والإجراءات البسيطة، والعناية بالجروح، وتثقيف المرضى، وتنسيق الإحالات الطبية. يقدم د. علي رعاية قائمة على الاستشارة باللغات العربية والإنجليزية والروسية، مع توصيات علاجية تعتمد على التقييم الطبي والاحتياجات الفردية لكل مريض.",
    servicesEn: [
      "General Practice Consultation",
      "Adult & Pediatric Medical Assessment",
      "Weight Management Consultation",
      "Endolift Consultation",
      "Diagnostic Review & Referral Coordination",
      "Minor Procedures & Wound Care",
      "Patient Counselling & Follow-Up"
    ],
    servicesAr: [
      "استشارة الطب العام",
      "التقييم الطبي للبالغين والأطفال",
      "استشارة إدارة الوزن",
      "استشارة إندولفت",
      "مراجعة التشخيص وتنسيق الإحالات",
      "الإجراءات البسيطة والعناية بالجروح",
      "تثقيف المرضى والمتابعة"
    ],
    certificationsEn: [
      "DHA Licensed General Practitioner — Dubai",
      "Emergency Specialist Certification — Syrian Ministry of Health",
      "More than 10 years of clinical experience in general, emergency, and acute medical care"
    ],
    certificationsAr: [
      "طبيب عام مرخص من هيئة الصحة بدبي — دبي",
      "شهادة اختصاص طب الطوارئ — وزارة الصحة السورية",
      "خبرة سريرية تزيد عن 10 سنوات في الطب العام والطوارئ والرعاية الحادة"
    ],
    photoUrl: "/manus-storage/dr-ali-profile_5e33fafb.jpg",
    videoUrl: "/manus-storage/dr-ali-profile-web_4240cc5e.mp4",
    waMsgEn: "Hi, I'd like to book an appointment with Dr. Ali Ahmad.",
    waMsgAr: "مرحباً، أريد حجز موعد مع د. علي أحمد."
  }
];

export const DOCTOR_CARD_ORDER = [
  "dr-ali-ahmad",
  "dr-fatima-salah",
  "dr-mohammed-alsammarraie",
  "dr-samira-mohammadi",
  "dr-hassan-alhouri",
  "nisreen-abdelmonaem",
  "dr-farouk-khallaf",
  "dr-radwa-abdulhadi",
  "dr-mohammad-khadour",
  "dr-asmaa-ebied",
  "dr-rwaida-alkubati",
  "dr-aaya-alsadi",
] as const;

const doctorBySlug = new Map(doctorProfiles.map((doctor) => [doctor.slug, doctor]));

export const doctors: DoctorProfile[] = DOCTOR_CARD_ORDER.map((slug) => {
  const doctor = doctorBySlug.get(slug);
  if (!doctor) {
    throw new Error(`Doctor profile missing from requested card order: ${slug}`);
  }
  return doctor;
});
